import { useState, type KeyboardEvent } from 'react';
import { comandosPara, type ComandoMia } from './catalogoComandosMia';

/**
 * Lista dos comandos com / enquanto a pessoa digita: setas escolhem, Enter ou Tab usa,
 * Esc limpa. O campo continua sendo o input do compositor.
 */
export function useComandosMia(texto: string, acoes: readonly number[], onEscolher: (comando: ComandoMia) => void) {
  const lista = comandosPara(texto, acoes);
  const [indice, setIndice] = useState(0);
  const atual = Math.min(indice, Math.max(0, lista.length - 1));

  function onKeyDown(event: KeyboardEvent<HTMLInputElement>, limpar: () => void) {
    if (lista.length === 0) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      const passo = event.key === 'ArrowDown' ? 1 : -1;
      setIndice((atual + passo + lista.length) % lista.length);
    } else if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      setIndice(0);
      onEscolher(lista[atual]);
    } else if (event.key === 'Escape') {
      event.preventDefault();
      setIndice(0);
      limpar();
    }
  }

  return { lista, atual, onKeyDown, escolher: onEscolher };
}
